<template>
  <div id="app">
<!--    <router-view :key="$route.fullPath"></router-view>-->
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  created() {
    // 在页面加载时读取sessionStorage里的状态信息
    if (localStorage.getItem('houseInfo')) {
      this.$store.commit('inHouseInfo', JSON.parse(localStorage.getItem('houseInfo')));
    }

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //text-align: center;
  color: #2c3e50;
  //margin-top: 60px;
}
</style>
